import { useCallback } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

// Opening a conversation about a patient (from the list, the folded list or
// the start screen) also opens that patient's page next to it. Only on a
// clinician's click: a conversation restored on load or chosen by following
// the open page never navigates.
export function useOpenPatientPage() {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  return useCallback(
    (patientId: number | null | undefined) => {
      if (patientId == null) return;
      const path = `/app/patients/${patientId}`;
      if (pathname !== path) navigate(path);
    },
    [navigate, pathname],
  );
}
